var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error-page"},[(_vm.isValidating)?_c('div',{staticClass:"error-desc"},[_vm._v("取消订阅中……")]):_c('div',{staticClass:"error-desc"},[_vm._v(_vm._s(_vm.msg))])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isValidating),expression:"!isValidating"}],staticClass:"error_end"},[_vm._v("——高擎论文评审中心")])])
}
var staticRenderFns = []

export { render, staticRenderFns }